import { Location } from '@cobliteam/common-types';
import { Button, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { Link } from 'react-router-dom';

type PageErrorProps = {
  message?: string;
  showLogo?: boolean;
};

function PageError({ message, showLogo = false }: PageErrorProps) {
  return (
    <div data-testid='page-error' key='page-error' className='relative flex h-full flex-col items-center justify-center gap-4 text-center'>
      {showLogo && <div className='absolute top-0 left-0 p-4'>{/* You can import and use your logo here if needed */}</div>}
      <Icon name='file-x' size='4xl' className='box-content overflow-visible rounded-full bg-primary-2 p-10' />
      <Typography variant='heading-2xl' className='font-bold' as='h1'>
        {message || 'Algum error inesperado aconteceu.'}
      </Typography>
      <Typography variant='input-placeholder'>Estamos trabalhando para que este erro seja corrigido o mais rápido possível.</Typography>
      <Link to={Location.HOME}>
        <Button variant='ghost' startIcon={<Icon name='rotate-cw' />} onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </Link>
    </div>
  );
}

export default PageError;
